import { gql } from '@apollo/client';

const setImpression = gql`
  mutation SetImpressionRequest(
    $grain: OdProtosVariantData_GrainInput
    $key: String!
    $variant_value: String!
  ) {
    variant {
      setImpression(input: { grain: $grain, key: $key, variantValue: $variant_value }) {
        _empty
      }
    }
  }
`;

export default setImpression;
